import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "content"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
var style = {
  container: function container(theme) {
    return /*#__PURE__*/css(theme.breakpoints.mq(theme.typography.banner.text), {
      position: 'relative',
      marginTop: 0,
      marginBottom: '0.5rem',
      paddingLeft: theme.direction === 'ltr' ? '1rem' : undefined,
      paddingRight: theme.direction === 'rtl' ? '1rem' : undefined,
      paddingInlineStart: '1rem',
      letterSpacing: 'normal',
      '&:last-child': {
        marginBottom: 0
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:container;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhbm5lckl0ZW0udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVErQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9CYW5uZXJJdGVtLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuXG5pbXBvcnQgeyBjc3MsIGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdHlwZSB7IFRoZW1lIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHR5cGUgeyBCYW5uZXJJdGVtUHJvcHMgfSBmcm9tICcuLi90eXBlcyc7XG5cbmNvbnN0IHN0eWxlID0ge1xuICBjb250YWluZXI6ICh0aGVtZTogVGhlbWUpID0+IGNzcyhcbiAgICB0aGVtZS5icmVha3BvaW50cy5tcSh0aGVtZS50eXBvZ3JhcGh5LmJhbm5lci50ZXh0KSxcbiAgICB7XG4gICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgIG1hcmdpblRvcDogMCxcbiAgICAgIG1hcmdpbkJvdHRvbTogJzAuNXJlbScsXG4gICAgICBwYWRkaW5nTGVmdDogdGhlbWUuZGlyZWN0aW9uID09PSAnbHRyJyA/ICcxcmVtJyA6IHVuZGVmaW5lZCxcbiAgICAgIHBhZGRpbmdSaWdodDogdGhlbWUuZGlyZWN0aW9uID09PSAncnRsJyA/ICcxcmVtJyA6IHVuZGVmaW5lZCxcbiAgICAgIHBhZGRpbmdJbmxpbmVTdGFydDogJzFyZW0nLFxuICAgICAgbGV0dGVyU3BhY2luZzogJ25vcm1hbCcsXG4gICAgICAnJjpsYXN0LWNoaWxkJzoge1xuICAgICAgICBtYXJnaW5Cb3R0b206IDAsXG4gICAgICB9LFxuICAgIH0sXG4gICksXG59O1xuXG5jb25zdCBCYW5uZXJJdGVtOiBSZWFjdC5GQzxCYW5uZXJJdGVtUHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNsYXNzTmFtZSxcbiAgY29udGVudCxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPGxpXG4gICAgey4uLnVuaGFuZGxlZFByb3BzfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIGNzcz17c3R5bGUuY29udGFpbmVyfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogY29udGVudH1cbiAgPC9saT5cbik7XG5cbkJhbm5lckl0ZW0uZGlzcGxheU5hbWUgPSAnQmFubmVySXRlbSc7XG5cbmV4cG9ydCBkZWZhdWx0IEJhbm5lckl0ZW07XG4iXX0= */");
  }
};

var BannerItem = function BannerItem(_ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("li", _extends({}, unhandledProps, {
    className: className,
    css: style.container
  }), children != null ? children : content);
};

BannerItem.displayName = 'BannerItem';
export default BannerItem;